<template>
  <v-btn :id="id" :disabled="disabled" :block="isBlock" :depresed="depresed" :fab="fab" :small="small" :outlined="outlined" @click="$emit(action)" :color="color" v-bind="$attrs">
    <v-icon :class="fab ? '' : 'mr-1'" v-if="icon">{{ icon }}</v-icon>
    {{ fab ? "" : textButton }}
  </v-btn>
</template>

<script>
// @group Global Component
export default {
  inheritAttrs: false,
  props: {
    id:{
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    textButton: {
      type: String,
      default: "Simpan"
    },
    color: {
      type: String,
      default: "primary"
    },
    isBlock: {
      type: Boolean,
      default: false
    },
    depresed: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    fab: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: "save"
    }
  },
  computed: {
    smallSize() {
      return this.$vuetify.breakpoint.smAndUp ? this.small : true;
    }
  }
};
</script>
